import * as _ from "lodash-es";
import axios from "axios";
import { notifyAxiosError } from "@/notify";
import { MAX_PAGE_SIZE } from "@/constants";

export default {
  namespaced: true,
  state: {
    isDocUploading: false,
    documents: {},
  },
  mutations: {
    mergeDocuments: function (state, documents) {
      state.documents = { ...state.documents, ...documents };
    },
    setDocuments: function (state, documents) {
      state.documents = documents;
    },
    addDocument: function (state, newDocument) {
      state.documents = { ...state.documents, [newDocument.id]: newDocument };
    },
    docUploadStarted: function (state) {
      state.isDocUploading++;
    },
    docUploadFinished: function (state, newDocument) {
      if (newDocument) {
        state.documents = { ...state.documents, [newDocument.id]: newDocument };
      }
      state.isDocUploading--;
    },
    docDeleteFinished: function (state, documentId) {
      state.documents = _.omit(state.documents, documentId);
    },
  },
  getters: {
    isStepMoveDisabled: (state) => Boolean(state.isDocUploading),
  },
  actions: {
    fetchDocuments(context, { params, onSuccessAction = "setDocuments" } = {}) {
      return axios
        .get("/application-documents/", {
          params: {
            page_size: MAX_PAGE_SIZE,
            ...params,
          },
        })
        .then((response) => {
          const documents = _.keyBy(response.data.results, "id");
          context.commit(onSuccessAction, documents);
          return documents;
        }, notifyAxiosError);
    },
    fetchProfileDocuments(context, profileId) {
      return context.dispatch("fetchDocuments", {
        params: { student_profile: profileId },
      });
    },
  },
};
